import React, { useState } from 'react'
import Layout from '../../components/Layout'
import ResetPasswordForm from '../../components/Form/ResetPasswordForm'
import { Button } from '../../../../components'
import { useNavigate } from 'react-router-dom'
import { PageRoute } from '../../../../routes'
import { useTranslation } from 'react-i18next'

const ResetPassword: React.FC = () => {
    const { t } = useTranslation()
    const [success, setSuccess] = useState(false)
    const navigate = useNavigate()
    return (
        <>
            {!success ? (
                <Layout
                    pageTitle={t('auth.resetPassword.title')}
                    pageDescription={t('auth.resetPassword.description')}
                >
                    <ResetPasswordForm onSuceess={setSuccess} />
                </Layout>
            ) : (
                <Layout
                    pageTitle={t('auth.resetPassword.title')}
                    pageDescription={t('auth.resetPassword.successDescription')}
                >
                    <Button
                        onClick={() => {
                            navigate(PageRoute.Login)
                        }}
                        variant="outline-success-round"
                    >
                        {t('button.backToLogin')}
                    </Button>
                </Layout>
            )}
        </>
    )
}

export default ResetPassword
